import react from "react";
import "./style.less"
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import {  Carousel } from "antd";

export default class MobileSimulatorVideos extends react.Component {
    constructor(props) {
        super(props);
    }
    getEnter = (e) => {
        switch (e.index) {
            case 0:
                return {
                    rotate: 90,
                    opacity: 0,
                    y: -60,
                };
            case 10:
            case 1:
                return {
                    y: -60,
                    x: -10,
                    opacity: 0,
                };
            case 9:
            case 2:
                return {
                    y: -60,
                    x: 20,
                    opacity: 0,
                };
            case 3:
                return {
                    y: 60,
                    opacity: 0,
                };
            case 8:
            case 4:
                return {
                    x: 30,
                    opacity: 0,
                };
            case 5:
                return {
                    enter: [
                        {
                            scale: 2,
                            opacity: 0,
                            type: 'set',
                        },
                        { scale: 1.2, opacity: 1, duration: 300 },
                        { scale: 0.9, duration: 200 },
                        { scale: 1.05, duration: 150 },
                        { scale: 1, duration: 100 },
                    ],
                    leave: {
                        opacity: 0, scale: 0,
                    },
                };
            case 6:
                return {
                    scale: 0.8,
                    x: 30,
                    y: -10,
                    opacity: 0,
                };
            case 7:
                return {
                    scale: 0.8,
                    x: 30,
                    y: 10,
                    opacity: 0,
                };
            default:
                return {
                    opacity: 0,
                };
        }
    }
    render() {
        return (
            <div className="mobile-simulator-videos">
                <h2 className="title">
                    <Texty enter={this.getEnter} leave={this.getEnter}>{'模拟器真实截屏'}</Texty>
                </h2>
                <Carousel>

                    <div key="a" className={"video-item"}>
                        <video style={{height:220}} src="http://qiniu.metridynamic.com/video/simulator2.mp4" autoPlay loop muted>

                        </video>
                        <div className="item-title">
                            飞行模拟
                        </div>
                        <div className="item-text">
                            <p>真实的飞行模拟系统可以实现手动和全自主飞行模拟。我们的系统配备了优秀的飞行模拟平台。内置全球各地的机场，画质细腻，细节丰富。</p>
                        </div>
                    </div>

                    <div key="b" className={"video-item"}>
                        <video style={{height:220}} src="http://qiniu.metridynamic.com/video/simulator.mp4" autoPlay loop muted>

                        </video>
                        <div className="item-title">精确模拟</div>
                        <div className="item-text">
                            <p>能够模拟各种天气条件，适用于测试飞行器的各种性能（如抗风能力等）。 精准的物理模型，无论是遥控飞行还是高级参数调整，都会带来逼真的飞行体验。</p>
                        </div>
                    </div>

                </Carousel>

            </div>
        )
    }
}
